var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiReschedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1832_3316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 14.6669V13.3336H12.6665V6.66694H3.33317V9.3336H1.99984V4.00027C1.99984 3.6336 2.1305 3.31983 2.39184 3.05894C2.65317 2.79805 2.96695 2.66738 3.33317 2.66694H3.99984V1.3336H5.33317V2.66694H10.6665V1.3336H11.9998V2.66694H12.6665C13.0332 2.66694 13.3472 2.7976 13.6085 3.05894C13.8698 3.32027 14.0003 3.63405 13.9998 4.00027V13.3336C13.9998 13.7003 13.8694 14.0143 13.6085 14.2756C13.3476 14.5369 13.0336 14.6674 12.6665 14.6669H9.99984ZM5.33317 16.0003L4.39984 15.0669L6.1165 13.3336H0.666504V12.0003H6.1165L4.39984 10.2669L5.33317 9.3336L8.6665 12.6669L5.33317 16.0003Z",
    fill: "#EE1D23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1832_3316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.000274658)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiReschedule);
export default __webpack_public_path__ + "static/media/ri-reschedule.188bf5806470fc5b933b9c0949fdc5bb.svg";
export { ForwardRef as ReactComponent };